import { useContext, useEffect, useCallback, useState } from 'react';
import {
    useNavigate,
    UNSAFE_NavigationContext as NavigationContext,
} from 'react-router-dom';

export const useBlocker = (confirmExit, when = true) => {
    const { navigator } = useContext(NavigationContext);

    useEffect(() => {
        if (!when) return;

        const push = navigator.push;

        navigator.push = (...args) => {
            const result = confirmExit(...args);
            if (result !== false) {
                push(...args);
            }
        };

        return () => {
            navigator.push = push;
        };
    }, [navigator, confirmExit, when]);
};

export const usePromptNavigation = (when = true) => {
    const navigate = useNavigate();
    const [showPrompt, setShowPrompt] = useState(false);
    const [lastLocation, setLastLocation] = useState(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);

    // handle blocking when user click on another route prompt will be shown
    const handleBlockedNavigation = useCallback(
        (nextLocation) => {
            if (!confirmedNavigation && when) {
                setShowPrompt(true);
                setLastLocation(nextLocation);
                return false;
            }
            return true;
        },
        [confirmedNavigation, when]
    );

    const stayOnPage = useCallback(() => {
        setShowPrompt(false);
        setConfirmedNavigation(false);
        setLastLocation(null);
    }, []);

    const leavePage = useCallback(() => {
        setShowPrompt(false);
        setConfirmedNavigation(true);
    }, []);

    const pausePage = useCallback(() => {
        setShowPrompt(false);
        setConfirmedNavigation(false);
    }, []);

    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            navigate(lastLocation.pathname);

            // Clean-up state on confirmed navigation
            setConfirmedNavigation(false);
        }
    }, [confirmedNavigation, lastLocation, navigate]);

    useBlocker(handleBlockedNavigation, when);
    return [showPrompt, leavePage, stayOnPage, pausePage];
};
